import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
export interface BreadcrumbItem {
  label: string;
  path?: string;
}
interface BreadcrumbProps {
  items: BreadcrumbItem[];
}
export function Breadcrumb({
  items
}: BreadcrumbProps) {
  // For mobile, show only last 2 items if more than 3
  const shouldCollapse = items.length > 3;
  const mobileItems = shouldCollapse ? items.slice(-2) : items;
  return <nav aria-label="Breadcrumb" className="mb-0" data-id="element-87">
      {/* Desktop Breadcrumb */}
      <ol className="hidden md:flex items-center space-x-2 text-sm flex-wrap" data-id="element-88">
        {/* Home Link */}
        <li data-id="element-89">
          <Link to="/" className="flex items-center text-slate-400 hover:text-cyan-400 transition-colors" aria-label="Home" data-id="element-90">
            <Home className="h-4 w-4" data-id="element-91" />
          </Link>
        </li>

        {/* Breadcrumb Items */}
        {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return <li key={index} className="flex items-center space-x-2" data-id="element-92">
              <ChevronRight className="h-4 w-4 text-slate-600" data-id="element-93" />
              {isLast || !item.path ? <span className="text-cyan-400 font-medium" aria-current="page" data-id="element-94">
                  {item.label}
                </span> : <Link to={item.path} className="text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-95">
                  {item.label}
                </Link>}
            </li>;
      })}
      </ol>

      {/* Mobile Breadcrumb (Collapsed) */}
      <ol className="flex md:hidden items-center space-x-2 text-sm" data-id="element-96">
        {/* Home Link */}
        <li data-id="element-97">
          <Link to="/" className="flex items-center text-slate-400 hover:text-cyan-400 transition-colors" aria-label="Home" data-id="element-98">
            <Home className="h-4 w-4" data-id="element-99" />
          </Link>
        </li>

        {/* Show ellipsis if collapsed */}
        {shouldCollapse && <li className="flex items-center space-x-2" data-id="element-100">
            <ChevronRight className="h-4 w-4 text-slate-600" data-id="element-101" />
            <span className="text-slate-600" data-id="element-102">…</span>
          </li>}

        {/* Mobile Items */}
        {mobileItems.map((item, index) => {
        const isLast = index === mobileItems.length - 1;
        return <li key={index} className="flex items-center space-x-2" data-id="element-103">
              <ChevronRight className="h-4 w-4 text-slate-600" data-id="element-104" />
              {isLast || !item.path ? <span className="text-cyan-400 font-medium truncate max-w-[150px]" aria-current="page" title={item.label} data-id="element-105">
                  {item.label}
                </span> : <Link to={item.path} className="text-slate-400 hover:text-cyan-400 transition-colors truncate max-w-[120px]" title={item.label} data-id="element-106">
                  {item.label}
                </Link>}
            </li>;
      })}
      </ol>
    </nav>;
}